module.exports = __webpack_public_path__ + "img/waves-white.c31b9ada.svg";